
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-41f3bd4d&scoped=true!./css/inserirNotificacao.css")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./InserirNotificacao.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-41f3bd4d!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./InserirNotificacao.vue"),
  /* scopeId */
  "data-v-41f3bd4d",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/notificacao/InserirNotificacao.vue
// module id = 905
// module chunks = 1